// extracted by mini-css-extract-plugin
export default {"wrapper":"GB-z","viewport":"HB-z","container":"IB-z","slide":"JB-z"};